import styled from 'styled-components/native';

import IconCheckFill from '../../../assets/svg/IconCheckFill';
import { peacock, warrior, white } from '../../../constants/color';

interface Props {
  text: string;
}

const ReachThresholdHint = ({ text }: Props) => {
  return (
    <S.Wrapper>
      <IconCheckFill fillColor={peacock} />
      <S.Text>{text}</S.Text>
    </S.Wrapper>
  );
};

const S = {
  Wrapper: styled.View`
    height: 40px;
    padding-left: 15px;
    flex-direction: row;
    align-items: center;
    background-color: ${white};
  `,
  Text: styled.Text`
    margin-left: 8px;
    font-size: 13px;
    color: ${warrior};
  `,
};

export default ReachThresholdHint;
